/* @flow */
import React from 'react';

import cx from 'classnames';
import Image from 'components/Image.jsx';

import './styles/AffiliationStatus.scss';

const AffiliationStatus = React.createClass({

  propTypes: {
    title: React.PropTypes.string.isRequired,
    subtext: React.PropTypes.node,
  },

  render() {
    return (
      <div className={cx('AffiliationStatus', this.props.className)}>
        <Image
          className="AffiliationStatus-Bell"
          src={require('assets/images/bell.svg')}
        />
        <div className="AffiliationStatus-Title">
          {this.props.title}
        </div>
        <div className="AffiliationStatus-Subtext">
          {this.props.subtext}
        </div>
        {this.props.children}
      </div>
    );
  },
});

export default AffiliationStatus;



// WEBPACK FOOTER //
// ./src/organizations/components/AffiliationStatus.jsx